<template>
  <div>
    <v-data-table :headers="headers" :items="responses" :items-per-page="100" class="elevation-1">
      <template v-slot:item.Link="{ item }">
        <v-btn medium color="primary" :href="item.Link.replace('https://wb-bi-ppp-practice.firebaseapp.com/','/')" target="_blank">View</v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { links } from '../../_data/exports/table_data'

export default {
  data() {
    return {
      headers: [
        { text: "Name", value: "Name" },
        { text: "Email", value: "Email" },
        { text: "Document", value: "Document Name" },
        { text: "Country", value: "Country" },
        { text: "Type", value: "Survey" },
        { text: "Go To Submission", value: "Link" }
      ],
      responses: links
    };
  },
};
</script>